export function formatCurrency(
  amount: number,
  currency: string = "USD"
): string {
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(
    amount / 100
  );
}
